import styled from 'styled-components';
import { Form, Space } from 'antd';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export const StyledSpace = styled(Space)`
  width: 100%;
  .ant-space-item {
    flex: 1;
  }
`;

export const StyledTextAndCheckbox = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  font-size: ${({ isMobile }) => (isMobile ? 16 : 14)};
`;

export const InlineFormItem = styled(Form.Item)`
  flex-direction: row-reverse !important;
  align-items: baseline;
  gap: 8px;
  width: fit-content;
`;
